module.exports = __webpack_public_path__ + "img/trial2-1.517ca22d.png";